import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9811e640"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ecran-container",
  style: {"font-family":"'Roboto', sans-serif"}
}
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__color--label q-ma-md"
}
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = {
  key: 0,
  class: "app__label--medium app__color--semigray",
  style: {"padding-top":"5rem"}
}
const _hoisted_6 = { class: "first_line" }
const _hoisted_7 = {
  class: "app__property--medium",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_8 = {
  class: "app__human__time__period--small",
  style: {"color":"#7D7D7D"}
}
const _hoisted_9 = { style: {"color":"#7D7D7D","font-size":"small"} }
const _hoisted_10 = { class: "second_line" }
const _hoisted_11 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_12 = { style: {"min-width":"2rem"} }
const _hoisted_13 = { class: "app__property--medium" }
const _hoisted_14 = {
  key: 0,
  class: "app__human__time__period--small",
  style: {"color":"#7D7D7D"}
}
const _hoisted_15 = {
  key: 1,
  class: "app__human__time__period--small",
  style: {"color":"#7D7D7D"}
}
const _hoisted_16 = {
  key: 2,
  class: "app__human__time__period--small",
  style: {"color":"#7D7D7D"}
}
const _hoisted_17 = { style: {"padding-left":"2rem","display":"flex"} }
const _hoisted_18 = {
  key: 0,
  class: "app__human__time__period--small",
  style: {"color":"#7D7D7D"}
}
const _hoisted_19 = {
  key: 2,
  class: "third_line"
}
const _hoisted_20 = {
  key: 0,
  class: "app__text__alert--small app__color--orange",
  style: {"padding-left":"1rem"}
}
const _hoisted_21 = {
  key: 1,
  class: "app__text__alert--small app__color--orange",
  style: {"padding-left":"1rem"}
}
const _hoisted_22 = { style: {"display":"flex","align-items":"center","flex-direction":"column","max-width":"35%"} }
const _hoisted_23 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_24 = {
  class: "text",
  style: {"color":"grey"}
}
const _hoisted_25 = { style: {"display":"flex","align-items":"center","flex-direction":"column","max-width":"35%"} }
const _hoisted_26 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_27 = {
  class: "text",
  style: {"color":"grey"}
}
const _hoisted_28 = { style: {"display":"flex","align-items":"center","flex-direction":"column","max-width":"35%"} }
const _hoisted_29 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_30 = {
  class: "text",
  style: {"color":"grey"}
}
const _hoisted_31 = { style: {"display":"flex","align-items":"center","flex-direction":"column","max-width":"35%"} }
const _hoisted_32 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_33 = {
  class: "text",
  style: {"color":"grey"}
}
const _hoisted_34 = { class: "shopping_cart__container--btns btns_line" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "shop",
                style: {"font-size":"2rem","top":"-3px"},
                color: "primary"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.requests_and_offers')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.offersHeaders.length >300)
        ? (_openBlock(), _createBlock(_component_q_input, {
            key: 1,
            "bottom-slots": "",
            modelValue: _ctx.inputSearchOffer,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputSearchOffer) = $event)),
            dense: "",
            style: {"margin-left":"auto"}
          }, {
            append: _withCtx(() => [
              (_ctx.inputSearchOffer !== '')
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.inputSearchOffer = '')),
                    class: "cursor-pointer"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_icon, { name: "search" })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.offersHeaders.length ==0 && !_ctx.loadingOffers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('message.no_offers')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offersHeaders, (offer) => {
        return (_openBlock(), _createElementBlock("div", {
          key: offer.offerId,
          class: _normalizeClass(["offer_div", { 'is--deleting': (offer.offerId==_ctx.appidToBeDeleted) }])
        }, [
          (offer.offerId==_ctx.appidToBeCancelled || offer.offerId==_ctx.appidToBeRecalled)
            ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                key: 0,
                indeterminate: "",
                color: "secondary",
                style: {"position":"absolute"}
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.id_offer')) + " " + _toDisplayString(offer.offerId), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(offer.trackCreationDate), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(offer.nume_utilizator), 1)
            ]),
            _createVNode(_component_q_btn, {
              outline: "",
              color: "blue",
              size: "sm",
              "no-caps": "",
              label: _ctx.$t('message.request_details'),
              onClick: ($event: any) => (_ctx.onOpenCerere(offer.offerId, offer.trackCreationDate, offer.nume_utilizator))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10],
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.open_request')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["label", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (offer.offerSlid && offer.status=='o')
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      name: "check_circle_outline",
                      class: "text-amber",
                      style: {"font-size":"1.5rem"}
                    }))
                  : _createCommentVNode("", true),
                (offer.offerSlid && offer.status=='k')
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      name: "check_circle_outline",
                      class: "text-green",
                      style: {"font-size":"1.5rem"}
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.humanStatusOffer(offer.status)) + " ", 1),
                (offer.status=='p')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "- " + _toDisplayString(offer.trackCreationDate), 1))
                  : _createCommentVNode("", true),
                (offer.offerSlid && offer.status=='o')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "- " + _toDisplayString(offer.trackDateOfertare), 1))
                  : _createCommentVNode("", true),
                (offer.offerSlid && offer.status=='k')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "- " + _toDisplayString(offer.trackDateAccept), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              (offer.status=='p')
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('message.requested_term')) + "-" + _toDisplayString(_ctx.timeDateHuman(offer.termenLivrareSolicitat,'YYYY-MM-DD')), 1))
                : _createCommentVNode("", true),
              (offer.offerSlid)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    outline: "",
                    "no-caps": "",
                    color: "blue",
                    size: "sm",
                    label: _ctx.$t('message.offer') + ' ' + offer.offerSlid,
                    onClick: ($event: any) => (_ctx.onOpenOferta(offer.offerId, offer.offerSlid, offer.trackDateOfertare, offer.nume_utilizator))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, {
                        anchor: "top middle",
                        self: "bottom middle",
                        offset: [10, 10],
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.open_offer')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["label", "onClick"]))
                : _createCommentVNode("", true),
              (offer.offerSlid && offer.dateWhenOfferExpire && offer.status=='o')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (new Date(offer.dateWhenOfferExpire) < new Date())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t('message.offer_expired')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('message.expira')) + " " + _toDisplayString(_ctx.timeUntilFutureDate(offer.dateWhenOfferExpire,'YYYY-MM-DD HH:mm')), 1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$q.platform.is.desktop ? 'fourth_line' : 'fifth_line')
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_q_btn, {
                  disable: offer.status=='p' || offer.status=='c',
                  flat: "",
                  align: "center",
                  "no-caps": "",
                  onClick: ($event: any) => (_ctx.generareOfertaPDFRO(offer.offerSlid))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "picture_as_pdf",
                      color: "primary"
                    }),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('message.confirmation')) + " BG", 1)
                  ]),
                  _: 2
                }, 1032, ["disable", "onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_q_btn, {
                  disable: offer.status=='p' || offer.status=='c',
                  flat: "",
                  align: "center",
                  "no-caps": "",
                  onClick: ($event: any) => (_ctx.generareOfertaPDFENG(offer.offerSlid))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "picture_as_pdf",
                      color: "primary"
                    }),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('message.confirmation')) + " ENG", 1)
                  ]),
                  _: 2
                }, 1032, ["disable", "onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_q_btn, {
                  disable: offer.status=='p' || offer.status=='c',
                  flat: "",
                  align: "center",
                  "no-caps": "",
                  style: {"min-width":"4rem","max-width":"4rem"},
                  onClick: ($event: any) => (_ctx.generateFacturi(offer))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "picture_as_pdf",
                      color: "primary"
                    }),
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('message.invoices')), 1)
                  ]),
                  _: 2
                }, 1032, ["disable", "onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_q_btn, {
                  disable: offer.status=='p' || offer.status=='c',
                  flat: "",
                  align: "center",
                  "no-caps": "",
                  style: {"min-width":"4rem","max-width":"4rem"},
                  onClick: ($event: any) => (_ctx.generareCertificate(offer))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "picture_as_pdf",
                      color: "primary"
                    }),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('message.certificates')), 1)
                  ]),
                  _: 2
                }, 1032, ["disable", "onClick"])
              ])
            ])
          ], 2),
          _createElementVNode("div", _hoisted_34, [
            (offer.status!='k')
              ? (_openBlock(), _createBlock(_component_q_icon, {
                  key: 0,
                  style: {"cursor":"pointer","font-size":"1.5rem","color":"red"},
                  name: "delete_forever",
                  onClick: ($event: any) => (_ctx.askCancelOffer(offer.offerId))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, {
                      anchor: "top middle",
                      self: "bottom middle",
                      offset: [10, 10],
                      "transition-show": "scale",
                      "transition-hide": "scale"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('message.cancel_request')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128))
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.fixed,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fixed) = $event)),
      "full-width": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "my_card" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, _toDisplayString(_ctx.popupTitle), 3),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      "no-caps": "",
                      color: "primary",
                      onClick: _ctx.downloadPDF,
                      icon: "download",
                      style: {"margin-left":"1rem","cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('message.download')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      "no-caps": "",
                      flat: "",
                      color: "primary",
                      icon: "download",
                      onClick: _ctx.downloadPDF,
                      style: {"cursor":"pointer"}
                    }, null, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                _createVNode(_component_q_space),
                (_ctx.isLoadingOffer)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 2,
                      color: "black",
                      size: _ctx.$q.platform.is.mobile ? '1.5em' : '3em'
                    }, null, 8, ["size"]))
                  : _createCommentVNode("", true),
                (_ctx.isLoadingOffer)
                  ? (_openBlock(), _createBlock(_component_q_space, { key: 3 }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: ""
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
                  : _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 5,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.widthPdf=300))
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
              ]),
              _: 1
            }),
            (_ctx.$q.platform.is.mobile)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 0,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isLoadingOffer)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeWitdhPdf('in'))),
                          icon: "zoom_in",
                          style: {"margin-bottom":"8px"},
                          loading: _ctx.clicked
                        }, null, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isLoadingOffer)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeWitdhPdf('out'))),
                          icon: "zoom_out",
                          style: {"margin-left":"10px","margin-bottom":"8px"},
                          loading: _ctx.clicked
                        }, null, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    _hoisted_35,
                    _createVNode(_component_vue_pdf_embed, {
                      source: _ctx.pdf,
                      width: _ctx.widthPdf
                    }, null, 8, ["source", "width"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 1,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vue_pdf_embed, { source: _ctx.pdf }, null, 8, ["source"])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.areMoreCertificates,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.areMoreCertificates) = $event)),
      maximized: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "my_card_5" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, _toDisplayString(_ctx.popupTitle), 3),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { dense: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (certificat, index) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: certificat.ItemNo
                      }, {
                        default: _withCtx(() => [
                          (_ctx.$q.platform.is.mobile)
                            ? (_openBlock(), _createBlock(_component_q_card, {
                                key: 0,
                                class: "my_card_4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.item_no')) + ": ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(certificat.ItemNo), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _hoisted_36,
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.description')) + ": ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(certificat.Description), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_actions, { vertical: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        color: "primary",
                                        icon: "picture_as_pdf",
                                        onClick: ($event: any) => (_ctx.download_certificate_2(index))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 1,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.item_no')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(certificat.ItemNo), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 2,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.description')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(certificat.Description), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 3,
                                class: "pdf_icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    color: "primary",
                                    icon: "picture_as_pdf",
                                    onClick: ($event: any) => (_ctx.download_certificate_2(index))
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.areMoreInvoices,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.areMoreInvoices) = $event)),
      maximized: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'my_card_5' : 'my_card_6')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, _toDisplayString(_ctx.popupTitle), 3),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { dense: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedInvoices, (invoice) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: invoice.id
                      }, {
                        default: _withCtx(() => [
                          (_ctx.$q.platform.is.mobile)
                            ? (_openBlock(), _createBlock(_component_q_card, {
                                key: 0,
                                class: "my_card_4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.invoice')) + ": ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(invoice.id), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_actions, { vertical: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        color: "primary",
                                        icon: "picture_as_pdf",
                                        onClick: ($event: any) => (_ctx.download_invoice(invoice.id))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 1,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.invoice')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(invoice.id), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 2,
                                class: "pdf_icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    color: "primary",
                                    icon: "picture_as_pdf",
                                    onClick: ($event: any) => (_ctx.download_invoice(invoice.id))
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.areMoreInvoicesCertificate,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.areMoreInvoicesCertificate) = $event)),
      maximized: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'my_card_5' : 'my_card_6')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, _toDisplayString(_ctx.$t('message.certificates')) + " " + _toDisplayString(_ctx.$t('message.offer')) + " " + _toDisplayString(_ctx.selectedOfferSlid), 3),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { dense: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedInvoices, (invoice) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: invoice.id
                      }, {
                        default: _withCtx(() => [
                          (_ctx.$q.platform.is.mobile)
                            ? (_openBlock(), _createBlock(_component_q_card, {
                                key: 0,
                                class: "my_card_4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.certificates')) + " " + _toDisplayString(_ctx.$t('message.invoice')) + ": ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(invoice.id), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_actions, { vertical: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        color: "primary",
                                        icon: "picture_as_pdf",
                                        onClick: ($event: any) => (_ctx.download_certificate(invoice.id))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 1,
                                "no-wrap": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.certificates')) + " " + _toDisplayString(_ctx.$t('message.invoice')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(invoice.id), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (_ctx.$q.platform.is.desktop)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 2,
                                class: "pdf_icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    color: "primary",
                                    icon: "picture_as_pdf",
                                    onClick: ($event: any) => (_ctx.download_certificate(invoice.id))
                                  }, null, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}